export default __webpack_public_path__ + "static/media/work-1.8c9d5566.jpg";